import { useCallback, useRef } from 'react';
/**
 * 스로틀링 커스텀 훅
 * 
 * 지정된 지연 시간 안에 함수가 여러 번 호출되는 것을 방지합니다.
 * 
 * @param callback 스로틀링할 함수
 * @param delay 지연 시간 (밀리초)
 * @returns 스로틀링된 함수
 */ export function useThrottle(callback, delay) {
    const lastCall = useRef(0);
    return useCallback((...args)=>{
        const now = Date.now();
        if (now - lastCall.current >= delay) {
            callback(...args);
            lastCall.current = now;
        }
    }, [
        callback,
        delay
    ]);
}
